module.exports = __webpack_public_path__ + "static/media/calendar-white.698b10f2.svg";